import React, { useEffect } from 'react'
import { Button, Form, Input, Modal, Space } from 'antd'
import styled from 'styled-components'
import ComponentTitle from '@/pages/safety-equipment/widgets/component-title'
import { useAddCaseTemplate } from './utils'
import { Message } from '@/components'
import { t } from '@/i18n'

interface PropsType {
  visible: boolean
  resourceIds: string[]
  onClose: () => void
}

const AddTemplateModal: React.FC<PropsType> = ({ visible, resourceIds, onClose }) => {
  const [form] = Form.useForm()
  // 添加用例模板
  const [addCaseTemplate, addCaseTemplateLoading] = useAddCaseTemplate()

  const onFinish = async (values: any) => {
    try {
      const res = await addCaseTemplate({
        name: values.name,
        resourceIds,
        verificationModeIds: [4, 9],
        sceneIds: [9],
      })

      if (!res || !res.data) return

      Message.success(t('保存用例模板成功'))
      onClose()
      form.resetFields()
    } catch (error) {}
  }

  useEffect(
    () => () => {
      form.resetFields()
    },
    [visible],
  )

  return (
    <Wrapper
      title={<ComponentTitle title={t('保存为模板')} />}
      open={visible}
      onCancel={onClose}
      footer={
        <Space>
          <Button type="default" onClick={onClose}>
            {t('取消')}
          </Button>
          <Button type="primary" onClick={() => form.submit()} loading={addCaseTemplateLoading}>
            {t('保存')}
          </Button>
        </Space>
      }
      centered
    >
      <Form form={form} onFinish={onFinish}>
        <Form.Item
          label={t('模板名称')}
          name="name"
          rules={[
            { required: true, message: t('请输入模板名称') },
            { max: 100, message: t('模板名称不能超过100个字符') },
          ]}
        >
          <Input style={{ width: 380 }} />
        </Form.Item>
      </Form>
    </Wrapper>
  )
}

export default AddTemplateModal

const Wrapper = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
      padding: 19px 20px;
    }

    .ant-modal-body {
      padding: 24px;

      .modal-content {
        display: flex;
        align-items: center;
        gap: 12px;

        .warning-icon {
          width: 20px;
          height: 20px;
          background: #ffb800;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
        }

        .warning-text {
          color: #1d2129;
          font-size: 14px;
        }
      }
    }

    .ant-modal-footer {
      border-top: none;
      padding: 0 24px 16px;

      .ant-btn {
        height: 32px;
        padding: 0 16px;
        border-radius: 6px;

        &.cancel-btn {
          color: #666;
          border-color: #999;
        }

        &.ant-btn-primary {
          background: linear-gradient(270deg, #4238c9 100%, #4238c9 100%);
          border-color: #4238c9;

          &:hover {
            background: linear-gradient(270deg, #4238c9 0%, #6c65d4 100%);
            border-color: #6c65d4;
          }
        }
      }
    }
  }
`
